import React from "react";
import PropTypes from "prop-types";

import { MaterialUIGridContainer } from "core/MaterialUI";
import {
    TimelineGridItem,
    TimelineHeading,
    GridItemContent,
    GridItemContentHeading,
    Paragraph
} from "./styles";

const Timeline = ({ title, content }) => {
    return (
        <>
            {title && (
                <TimelineHeading type="h2" size="xl" bottomSpacing="4xl">
                    {title}
                </TimelineHeading>
            )}
            <MaterialUIGridContainer
                mobileMaxPadding={5}
                // passing in index 5 passes in the number "24" from the spacing array divided by 2 = 24px gutter as 12px around each item (see line 9 of core/MaterialUI/ for this spacing array)
                tabletMaxPadding={3}
                // passing in index 3 passes in the number "16" from the spacing array divided by 2 = 16px gutter as 8px around each item (see line 9 of core/MaterialUI/ for this spacing array)
                desktopMinPadding={10}
                // passing in index 10 passes in the number "64" from the spacing array divided by 2 = 64px gutter as 32px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            >
                {content.map(data => {
                    return (
                        <TimelineGridItem item sm={12} md={4} key={data.title}>
                            <GridItemContent>
                                <GridItemContentHeading type="h2" size="2xl">
                                    {data.title}
                                </GridItemContentHeading>
                                <GridItemContentHeading type="h6" size="xs">
                                    {data.subtitle}
                                </GridItemContentHeading>
                                <Paragraph>{data.text}</Paragraph>
                            </GridItemContent>
                        </TimelineGridItem>
                    );
                })}
            </MaterialUIGridContainer>
        </>
    );
};

Timeline.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    content: PropTypes.array.isRequired
};

export default Timeline;
